// Publiczny axios - BEZ JWT interceptora.
// Uzywany dla publicznych endpointow (np. /api/ui/sales-crm/public-offers/{token})
// gdzie klient nie jest zalogowany. Brak refresh tokena, brak Authorization headera.

import axios from 'axios';
import i18n from 'i18n';

const { REACT_APP_API_BASE_URL, REACT_APP_API_BASE_PATH } = process.env;

if (!REACT_APP_API_BASE_URL || !REACT_APP_API_BASE_PATH) {
  throw new Error('Specify REACT_APP_API_BASE_URL and REACT_APP_API_BASE_PATH in your .env file');
}

const publicAxiosInstance = axios.create();

publicAxiosInstance.defaults.baseURL = `${REACT_APP_API_BASE_URL}${REACT_APP_API_BASE_PATH}`;
publicAxiosInstance.defaults.headers.common['Accept'] = 'application/json';
publicAxiosInstance.defaults.headers.post['Content-Type'] = 'application/json';

publicAxiosInstance.interceptors.request.use((config) => {
  config.headers = {
    ...config.headers,
    'Content-Language': i18n.language
  };
  return config;
});

// Brak globalnego showMessage - public page renderuje wlasne komunikaty bledow
// (3 osobne: invalid / expired / canceled). Zwracamy surowy response.data, aby
// strona mogla zinterpretowac message/message_style we wlasnym layoucie.
publicAxiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.data) {
      return Promise.reject({ ...error.response.data, httpStatus: error.response.status });
    }
    return Promise.reject(error);
  }
);

export default publicAxiosInstance;
